export default class BankReconciliation {
    constructor() {
        this.id = "";
        this.container = "nixloc-finance-ofx";
        this.fileName = "";
    }
}